import { Injectable, NgZone } from '@angular/core';
import { SnackBarComponent } from '../../shared/modals/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NavigationStart, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone,
    router: Router
  ) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        snackBar.dismiss();
      }
    });
  }

  info(message?: string): void {
    this.zone.run(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
        duration: 5000,
        panelClass: 'info-snack-bar',
        announcementMessage: message || 'Info',
        data: {
          type: 'info',
        },
      });
    });
  }

  success(message?: string): void {
    this.zone.run(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
        duration: 5000,
        panelClass: 'success-snack-bar',
        announcementMessage: message || 'Success',
        data: {
          type: 'success',
        },
      });
    });
  }

  error(message?: string): void {
    this.zone.run(() => {
      this.snackBar.openFromComponent(SnackBarComponent, {
        verticalPosition: 'bottom',
        horizontalPosition: 'end',
        duration: 5000,
        panelClass: 'error-snack-bar',
        announcementMessage: message || 'Something went wrong',
        data: {
          type: 'error',
        },
      });
    });
  }
}
